'use strict';

var NS = 'http://jabber.org/protocol/shim';


module.exports = function (client) {

    client.disco.addFeature(NS);
    client.disco.addFeature(NS + '#SubID', NS);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/stanza.io/lib/plugins/shim.js
// module id = 351
// module chunks = 0